/**
 * Retail / storefront title case for labels shown to customers (categories, product types,
 * hub tiles, breadcrumbs). Each word is capitalized; hyphen-separated segments are handled;
 * pure numeric tokens are unchanged. Leading punctuation (e.g. "(") does not block casing.
 * Does not modify stored catalog data.
 */
export function formatDisplayTitle(text) {
  if (text == null || typeof text !== 'string') return '';
  let t = text.trim();
  if (!t) return '';
  t = t.replace(/\s*[\u2013\u2014]\s*/g, ' ');

  return t.replace(/[^\s-]+/g, (word) => titleCaseToken(word));
}

function titleCaseToken(word) {
  if (!word) return word;
  if (/^\d+$/.test(word)) return word;

  const letterIdx = word.search(/[a-zA-Z]/);
  if (letterIdx < 0) return word;

  return (
    word.slice(0, letterIdx) +
    word.charAt(letterIdx).toUpperCase() +
    word.slice(letterIdx + 1).toLowerCase()
  );
}

/** @deprecated Use formatDisplayTitle; kept for existing imports. */
export const formatProductTitle = formatDisplayTitle;
